module.exports = __webpack_public_path__ + "media/ctrip.585d399e.mp4";